// @core/api/endpoints/calendar/get_event.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  EventResponse,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Get event
 * Retrieves complete event details including attendees, location, conference data, reminders, and linked resources.
 */
export async function GetEvent(
  event_id: string,
  options?: RequestOptions
): Promise<EventResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/events/:event_id`;
  requestPath = requestPath.replace(':event_id', encodeURIComponent(event_id));
  const requestOptions = options;
  return client.get<EventResponse>(requestPath, { ...requestOptions });
}
